/* Theme selection, shared by the login page and the app shell.
 *
 * The choice persists under 'qorvex.theme' — the same key the terminal header
 * toggle uses — and is applied to <html data-theme> so every token in
 * theme.css flips at once. Light is the default — it is the product surface
 * the console is designed on; dark stays available for traders who run it.
 */
export type Theme = 'dark' | 'light'

const KEY = 'qorvex.theme'

export function currentTheme(): Theme {
  try {
    const saved = localStorage.getItem(KEY)
    if (saved === 'light' || saved === 'dark') return saved
  } catch { /* storage blocked: default applies */ }
  return 'light'
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme)
  try { localStorage.setItem(KEY, theme) } catch { /* non-fatal */ }
}

/** Apply the persisted choice before first paint. Returns what was applied. */
export function initTheme(): Theme {
  const theme = currentTheme()
  document.documentElement.setAttribute('data-theme', theme)
  return theme
}
